import { render } from "./sdn_notification_app.vue?vue&type=template&id=d48e2786"
import script from "./sdn_notification_app.vue?vue&type=script&lang=js"
export * from "./sdn_notification_app.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__